const w = window;
const d = document;
const b = 'body';
const viewport = 'html, body';

/*
 * YouTube IFrame API
 */
const ytbPlyrArr = [];
const ytbDataArr = [];

createYtbDataArr();
// console.log(ytbDataArr);

const tag = d.createElement('script');
	  tag.src = 'https://www.youtube.com/iframe_api';

const firstScriptTag = d.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const sttArr = {
	'-1' : '未開始（-1）',
	'0' : '終了（0）',
	'1' : '再生中（1）',
	'2' : '停止（2）',
	'3' : 'バッファリング中（3）',
	'5' : '頭出し済み（5）'
};

function onYouTubeIframeAPIReady() {
	for(var i = 0; i < ytbDataArr.length; i++) {
		ytbPlyrArr[i] = new YT.Player(ytbDataArr[i].ytbPlyrArea, {
			videoId: ytbDataArr[i].ytbMovId,
			playerVars: {
				rel: 0,
				controls: ytbDataArr[i].controlsOpt,
				playlist: ytbDataArr[i].ytbPlyLst,
				loop: 1,
				modestbranding: 1,
				enablejsapi: 1,
				playsinline: ytbDataArr[i].playsInlineOpt,
				cc_load_policy: 0
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
	}
}

function onPlayerReady(e) {
	ytbDataArrLoop(e, 'onReady');
}

function onPlayerStateChange(e) {
	ytbDataArrLoop(e, 'onStateChange');
}

function ytbDataArrLoop(e, fnc) {
	for(var i = 0; i < ytbDataArr.length; i++) {
		if(e.target.getIframe().id == ytbDataArr[i].ytbPlyrArea) {
			const autoMutePly = ytbDataArr[i].autoMutePly;
			const ytbStt = e.target.getPlayerState();
			
			const movDur = ytbPlyrArr[i].getDuration();
			const curtTime = ytbPlyrArr[i].getCurrentTime();
			
			switch(fnc) {
				case 'onReady':
					// console.log('【' + ytbDataArr[i].ytbPlyrArea + '】\n→ ' + '再生準備完了');
					
					if(autoMutePly) {
						ytbPlyrArr[i].mute().playVideo();
					}
					break;
				
				case 'onStateChange':
					// console.log('【' + ytbDataArr[i].ytbPlyrArea + '】\n→ ' + sttArr[ytbStt]);
					
					if(autoMutePly && ytbStt == 1) {
						ytbPlyrArr[i].setOption('captions', 'track', {});
						ytbPlyrArr[i].unloadModule('captions');
					}
					break;
			}
		}
	}
}

/*
 * add YouTube player
 */
function createYtbDataArr() {
	d.querySelectorAll('.js-get-ytb-data').forEach((elm) => {
		const addYtbDataArr = {};
		
		const getPlyrId = elm.getAttribute('id');
		const getYtbDataOpt = elm.dataset.ytbDataOpt
			  ? JSON.parse(elm.dataset.ytbDataOpt)
			  : {};
		
		addYtbDataArr.ytbPlyrArea = getPlyrId;
		
		for(const key in getYtbDataOpt) {
			addYtbDataArr[key] = getYtbDataOpt[key];
		}
		
		// console.log(addYtbDataArr);
		
		ytbDataArr.push(addYtbDataArr);
	});
}
